import React, { useState } from 'react';
// import DocUploadModal from '../../../views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import DynamicDocUploadModal from '../../../views/pages/manage/common/fileUpload/DynamicDocUploadModal';
import AAutoComplete from '../../../views/pages/manage/common/form-fields-mui/AAutoComplete';
import { saveFileData } from './utils';
import AButton from '../../../views/pages/manage/common/form-fields-mui/AButton';
import { ReactComponent as UploadIcon } from "assets/img/svg/fi_upload.svg";
import { EMPTY_FILTER_FORM } from './constants';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';


const UploadTransferFile = ({
    permittedBulkTransferTypes,
    setLoading,
    getBulkTransferRequestsList
}) => {

    const [isUploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [transferType, setTransferType] = useState("");

  const handleSaveUpload = async (allFilesData, setFileStates, setFileDataStates) => {
        try {
            debugger
            setLoading(true);
            // allFilesData is an object with each file's details
            // Example: { transferFile: { s3Key, fileName, fieldName, label, isMandatory }, supportingFile: {...} }
            const resp = await saveFileData(allFilesData, transferType);
            if(resp?.code === 200){
                setUploadDialogOpen(false);
                successToast(resp?.message);
                getBulkTransferRequestsList({pageNo : 0 , filters : EMPTY_FILTER_FORM})
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);

        }
    }


    return (
        <div>

            <AButton
                variant='primary_filled'
                size='xs'
                onClick={() => setUploadDialogOpen(true)}
            >
                <UploadIcon className='mr-2'/>
                Upload Template
            </AButton>

            {/* <DocUploadModal
                open={isUploadDialogOpen}
                setOpen={setUploadDialogOpen}
                saveHandler={(s3Key, fileName, fileData) => {
                    handleSaveUpload(fileData,fileName)
                }}
                acceptedFileTypes={[".csv", ".xls"]}
                maxUploadFileSize={5}
                serviceName={transferType?.value}
                uniqueKeyParameter={"paymentCollectionImage"}
                //   uploadedFileS3Key={fileData?.bulkUploadS3Key}
                //   uploadedFileName={fileData?.fileName}
                modalTitle={"Upload transfer file"}
                key={isUploadDialogOpen}
                propStyle={{ overflow: 'auto', maxWidth: '325px' }}
                paymentMode={transferType}
                isBulkCollection={true}
                customComponent={<AAutoComplete
                    label="Transfer Type*"
                    placeholder="Select to add"
                    className='mb-1'
                    items={permittedBulkTransferTypes}
                    currentValue={transferType}
                    isMulti={false}
                    handleChange={(value) => {
                        setTransferType(value)
                    }}
                />}

            /> */}

            <DynamicDocUploadModal
                open={isUploadDialogOpen}
                setOpen={setUploadDialogOpen}
                saveHandler={(allFilesData) => {
                    handleSaveUpload(allFilesData)
                }}
                acceptedFileTypes={[".csv", ".xls"]}
                maxUploadFileSize={5}
                serviceName={transferType?.value}
                uniqueKeyParameter={"bulkTransferFile"}
                modalTitle={"Upload transfer file"}
                key={isUploadDialogOpen}
                propStyle={{ overflow: 'auto', maxWidth: '325px' }}
                paymentMode={transferType}
                isBulkCollection={true}
                fileUploads={[
                    {
                        label: "Transfer File*",
                        fieldName: "transferFile",
                        uploadLabel: "Upload Transfer File",
                        uploadedFileS3Key: "",
                        uploadedFileName: "",
                        isMandatory: true,
                        acceptedFileTypes: [".csv", ".xls"]
                    },
                    {
                        label: "Supporting File*",
                        fieldName: "supportingFile",
                        uploadLabel: "Upload Supporting File",
                        uploadedFileS3Key: "",
                        uploadedFileName: "",
                        isMandatory: true,
                        acceptedFileTypes: [".pdf"]
                    }
                ]}
                customComponent={<AAutoComplete
                    label="Transfer Type*"
                    placeholder="Select to add"
                    className='mb-1'
                    items={permittedBulkTransferTypes}
                    currentValue={transferType}
                    isMulti={false}
                    handleChange={(value) => {
                        setTransferType(value)
                    }}
                />}
            />
        </div>
    );
}

export default UploadTransferFile;